/**
 * Format currency value for display
 */
export function formatCurrency(value: number, currency: string): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatNumber(value: number, decimals = 2): string {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/**
 * Converts `amount` from `fromCurrency` to `toCurrency` using the provided
 * convert function. Returns 0 if conversion fails (e.g. unknown currency).
 */
export function safeConvertCurrency(
  amount: number,
  fromCurrency: string,
  toCurrency: string,
  convert: (amount: number, from: string, to: string) => number
): number {
  if (!amount || !fromCurrency) return 0;
  try {
    return convert(amount, fromCurrency, toCurrency);
  } catch {
    return 0;
  }
}
